import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 100;

export const useHeaderStyles = makeStyles(theme => ({
  headerContainer: {
    backgroundColor: "#131313",
    borderBottom: "1px solid #363636",
    position: "sticky",
    top: 0,
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    height: "90px",
    [theme.breakpoints.down("sm")]: {
      height: "80px",
    },
  },
  appBar: {
    marginTop: "10px",
    padding: "0",
    backgroundColor: "#131313",
    boxShadow: "none",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
  burgerButton: {
    marginRight: theme.spacing(2),
    color: "#ffffff",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    "& img": {
      maxWidth: "90px",
      height: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      columnGap: "15px",
      marginTop: "5px",

      "& img": {
        width: "55%",
        margin: "1px 0 0 15px",
      },
    },
  },
  grow: {
    flexGrow: 1,
  },
  subscriptionBadgeContainer: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(1),
    },
  },
  profileButton: {
    borderRadius: "30px",
    // border: "1px solid #f06ec4",
    color: "#fff",
    cursor: "pointer",
    padding: "6px 16px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    gap: "8px",
    "&:hover": {
      color: "#FF68D5",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "4px 12px",
      fontSize: "12px",
      "& .MuiButton-startIcon": {
        marginRight: "4px",
      },
    },
  },
  profileAvatar: {
    width: 38,
    height: 38,
    fontSize: "14px",
    backgroundColor: "#FF68D5",
    color: "#0d0d0d",
    [theme.breakpoints.down("sm")]: {
      width: 32,
      height: 32,
      fontSize: "12px",
    },
  },
  settingsButton: {
    color: "#FF68D5",
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    marginLeft: "10px",
    "&:hover": {
      color: "#FF68D5",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "32px",
      minHeight: "32px",
      padding: "6px",
      marginLeft: theme.spacing(0.5),
      "& .MuiButton-startIcon": {
        margin: 0,
      },
      "& .buttonText": {
        display: "none",
      },
    },
  },
  notificationButton: {
    color: "#fff",
    // border: "1px solid #FAFAFA33",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      // padding: "6px",
    },
  },
  logOutButton: {
    marginLeft: theme.spacing(1),
    color: "#FF68D5",
    [theme.breakpoints.down("sm")]: {
      padding: "6px",
      marginLeft: theme.spacing(0.5),
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#121212",
  },
  profileMenuPaper: {
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: "#131313",
    color: "#ffffff",
    border: "1px solid #2a2a2a",
    boxShadow:
      "0px 12px 28px rgba(0, 0, 0, 0.45), 0px 0px 1px rgba(255, 255, 255, 0.05)",
    "& .MuiMenuItem-root": {
      color: "#ffffff",
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      padding: "10px 16px",
      "&:hover": {
        backgroundColor: "rgba(255, 104, 213, 0.12)",
      },
      "& .MuiListItemIcon-root": {
        color: "#FF68D5",
        minWidth: 32,
      },
    },
  },
  notificationPopoverPaper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    "& .MuiPaper-root": {
      backgroundColor: "transparent",
    },
  },
}));
